type RevenueIntelligenceProductUser = {
  role?: "super_admin" | "admin" | "manager" | "employee" | null;
  is_super_admin?: boolean | null;
  company?: {
    product_access_revenue_intelligence?: boolean | null;
  } | null;
} | null | undefined;

export function hasRevenueIntelligenceProductAccess(
  user: RevenueIntelligenceProductUser,
) {
  if (!user || user.role === "manager" || user.role === "employee") {
    return false;
  }

  if (user.role === "super_admin" || user.is_super_admin === true) {
    return true;
  }

  return user.role === "admin"
    && user.company?.product_access_revenue_intelligence === true;
}
